export const localisedSounds = [
  {
    name: "desert-storm-atmos",
    lat: -20.44865,
    lng: -69.50902,
    src: "assets/audio/desert-storm-atmos.mp3",
    db: 80,
    loop: true
  },
  {
    name: "desert-winds-quiet",
    lat: -20.4463,
    lng: -69.51475,
    src: "assets/audio/desert-winds-quiet.mp3",
    db: 80,
    loop: true
  },
  {
    name: "desert-winds-quiet-2",
    lat: -20.43883,
    lng: -69.53473,
    src: "assets/audio/desert-winds-quiet.mp3",
    db: 80,
    loop: true
  },
  {
    name: "dogs-barking",
    lat: -20.435150980335941,
    lng: -69.545929008780504,
    src: "assets/audio/dogs-barking.mp3",
    db: 80,
    loop: true
  },
  {
    name: "bar1",
    lat: -20.33811,
    lng: -69.65581,
    src: "assets/audio/bar.mp3",
    db: 40,
    loop: true
  },
  {
    name: "highway-front-mid",
    lat: -20.32409,
    lng: -69.75246,
    src: "assets/audio/highway-front-mid.mp3",
    db: 50,
    loop: true
  },
  {
    name: "drone-distant",
    lat: -20.31347,
    lng: -69.7629,
    src: "assets/audio/drone-distant.mp3",
    db: 90,
    loop: true
  },
  {
    name: "drone-hovering",
    lat: -20.29849,
    lng: -69.79125,
    src: "assets/audio/drone-hovering.mp3",
    db: 80,
    loop: true
  },
  {
    name: "tier-1",
    lat: -20.26018,
    lng: -69.78619,
    src: "assets/audio/tier-1.mp3",
    db: 30,
    loop: true
  },
  {
    name: "church-bell",
    lat: -20.33692,
    lng: -69.65623,
    src: "assets/audio/church-bell.mp3",
    db: 30,
    loop: true,
    rolloffFactor: 1.5,
  },
  {
    name: "humberstone-wind",
    lat: -20.206147746865163,
    lng: -69.79750517944157,
    src: "assets/audio/humberstone-wind.mp3",
    db: 30,
    loop: true,
  },
  {
    name: "humberstone-inside",
    lat: -20.204887688706446,
    lng: -69.79400234067319,
    src: "assets/audio/humberstone-inside.mp3",
    db: 30,
    loop: true,
  },
];
